// extracted by mini-css-extract-plugin
module.exports = {"title":"Projects_title__3Wp9f","create":"Projects_create__EM6Wi","studies":"Projects_studies__2e1Bv"};